// extracted by mini-css-extract-plugin
export default {"layout":"main_layout__iKmxb","container":"main_container__kkCPn","logo":"main_logo__Kan0P","link":"main_link__+OtTe"};